export default __webpack_public_path__ + "bd26b7ab262a194d7e94f54eb7f0adb1.png";